/* eslint-disable no-shadow */
import React, { useCallback, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import _map from 'lodash/map';
import _findLastKey from 'lodash/findLastKey';
import _toInteger from 'lodash/toInteger';
import _flatMap from 'lodash/flatMap';
import _some from 'lodash/some';
import _size from 'lodash/size';
import BP from 'styles/blocks/bloodPressure';
import { updateBloodPressureReading, removeBloodPressureReading, addBloodPressureReading } from 'redux/actions/consultation/answer';
import { STRINGS } from 'config';
import { BloodPressureFields } from './fields';
import { NextButton } from '../nextButton';

export function BloodPressure({ questionId, onClickNextQuestion }) {
  const mapState = useCallback(state => ({
    bloodPressure: state.consultationReducer.bloodPressureAnswer.bloodPressure,
  }), []);
  const { bloodPressure } = useMappedState(mapState);

  const dispatch = useDispatch();

  const [newFieldToFocus, setNewFieldToFocus] = useState(null);

  const handleUpdateReading = useCallback((id, field, value) => {
    dispatch(updateBloodPressureReading({ id, field, value }));
  }, [dispatch]);

  const handleAddNewBPField = useCallback(() => {
    const bpField = {
      systolic: '', diastolic: '', date: '', time: '', removable: true,
    };
    const readingId = _toInteger(_findLastKey(bloodPressure)) + 1;
    const newBloodPressureReading = { [readingId]: bpField };
    dispatch(addBloodPressureReading(newBloodPressureReading));
    setNewFieldToFocus(readingId);
  }, [dispatch, bloodPressure]);

  const handleRemoveBPField = useCallback(id => {
    dispatch(removeBloodPressureReading(id));
  }, [dispatch]);

  const [invalidFieldRef, setInvalidFieldRef] = useState(null);
  const bloodPressureReadings = _flatMap(bloodPressure, reading => _map(reading, field => field));
  const isSomeFieldsEmpty = _some(bloodPressureReadings, it => !it);
  const isSomeFieldsInvalid = _some(bloodPressure, ({ systolic, diastolic }) => systolic > STRINGS.BIOMETRICS.SYSTOLIC.HIGH || diastolic > STRINGS.BIOMETRICS.DIASTOLIC.HIGH
  || systolic < STRINGS.BIOMETRICS.SYSTOLIC.LOW || diastolic < STRINGS.BIOMETRICS.DIASTOLIC.LOW || parseInt(systolic, 10) < parseInt(diastolic, 10));

  return (
    <BP>
      {_map(bloodPressure, (reading, key) => (
        <BloodPressureFields
          reading={{ ...reading, date: (reading.date ? new Date(reading.date) : ''), time: (reading.time ? new Date(reading.time) : '') }}
          onUpdateReading={handleUpdateReading}
          key={`bloodPressureReadingsField-${key}`}
          id={key}
          onRemoveReading={handleRemoveBPField}
          invalidFieldRef={invalidFieldRef}
          setInvalidFieldRef={setInvalidFieldRef}
          isFocussed={newFieldToFocus === _toInteger(key)}
        />
      ))}
      <BP.FieldsContainer>
        {_size(bloodPressure) >= STRINGS.BIOMETRICS.MAX_READINGS ? (
          <BP.HelpLabel>You&apos;ve reached the maximum number of readings</BP.HelpLabel>
        ) : (
          <BP.AddButton type="button" onClick={handleAddNewBPField}>Add more readings</BP.AddButton>
        )}
      </BP.FieldsContainer>
      <NextButton dataAutomation={`nextButton-${questionId}`} onClick={onClickNextQuestion} isDisabled={isSomeFieldsEmpty || isSomeFieldsInvalid} />
    </BP>
  );
}
